import { format } from 'date-fns';

export function getNormalizedDate(date: string | Date) {
  return format(new Date(date), 'dd.MM.yyy');
}
